module.exports = __webpack_public_path__ + "static/fjp-cbdb63d27ab59a145188132c10b1af23.jpeg";